export default __webpack_public_path__ + "img/2d1bd766d2d2eb3cc2f5e1f337fdf2b5.png";